import { TOKEN_ADDRESSES } from "../constants/tokenaAddresses";

const networkType = process.env.REACT_APP_NETWORK?.trim().toUpperCase(); // will return string MAINNET | TESTNET
const Environment = TOKEN_ADDRESSES[networkType]


export default Environment;
